import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import ContractorService from "../../../../../../api/contractorService";
import { successToast, errorToast } from "../../../../../../_helper/helper";

const EmailModal = ({Toggle:toggle, modal, handleSubmitSendEmail, emailLoader}) => {
  
  const [selectedEmail, setSelectedEmail] = useState("");
  const [message, setMessage] = useState("");
  const [contractors, setContractors] = useState([]);
  const [contractorLoading, setContractorLoading] = useState(false);

  const role = JSON.parse(localStorage.getItem('role'))

  // Fetch contractors when modal opens and role is qa
  useEffect(() => {
    if (modal && role === 'qa') {
      fetchContractors();
    }
  }, [modal, role]);

  const fetchContractors = async () => {
    try {
      console.log('Fetching contractors for QA role...');
      setContractorLoading(true);
      const response = await ContractorService.getAllContractors();
      console.log('API Response:', response);
      console.log('Response data:', response.data);
      console.log('Response status:', response.status);
      
      if (response.status === 200) {
        // Check different possible response structures
        let contractorsData = null;
        
        if (response.data && response.data.contractors) {
          contractorsData = response.data.contractors;
        } else if (response.data && Array.isArray(response.data)) {
          contractorsData = response.data;
        } else if (response.data && response.data.data && response.data.data.contractors) {
          contractorsData = response.data.data.contractors;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          contractorsData = response.data.data;
        }
        
        console.log('Contractors data found:', contractorsData);
        
        if (contractorsData && Array.isArray(contractorsData)) {
          // Filter only active contractors
          const activeContractors = contractorsData.filter(contractor => contractor.active === true);
          console.log('Active contractors:', activeContractors);
          setContractors(activeContractors);
          console.log('Contractors state set:', activeContractors);
        } else {
          console.error('No contractors data found in response');
          errorToast('No contractors data found');
        }
      } else {
        console.error('API call failed with status:', response.status);
        errorToast('Failed to fetch contractors');
      }
    } catch (error) {
      errorToast('Error fetching contractors');
      console.error('Error fetching contractors:', error);
    } finally {
      setContractorLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    if (role === 'qa') {
      if (!selectedEmail || !message.trim()) {
        errorToast('Please select an email and enter a message');
        return;
      }
      console.log('Safety violation report submitted:', {
        selectedEmail,
        message
      });
      successToast('Safety violation report submitted successfully');
    } else {
      // Use the original handler for non-qa roles
      handleSubmitSendEmail(e, selectedEmail, message);
      return;
    }
    
    // Reset form and close
    setSelectedEmail('');
    setMessage('');
    toggle();
  };

  const handleModalClose = () => {
    // Reset form when closing
    setSelectedEmail('');
    setMessage('');
    setContractors([]);
    toggle();
  };

  return (
    <div>
   
      <Modal isOpen={modal} toggle={handleModalClose}>
        <ModalHeader toggle={handleModalClose}>
          {role === 'qa' ? 'Safety Violation Report' : 'Send a Message'}
        </ModalHeader>
        <Form onSubmit={handleFormSubmit}>
          <ModalBody>
            {/* Show Send a Message form directly for qa role, or conditionally for others */}
            {(role === 'qa' || !role) && (
              <>
                {role === 'qa' && (
                  <div style={{ 
                    marginBottom: '20px' 
                  }}>
                    <h5 style={{ 
                      color: '#dc3545',
                      marginBottom: '15px',
                      borderBottom: '2px solid #dc3545',
                      paddingBottom: '5px'
                    }}>
                      Send a Message
                    </h5>
                  </div>
                )}
                <FormGroup>
                  <Label for="emailDropdown">Select Email</Label>
                  <Input
                    type="select"
                    id="emailDropdown"
                    value={selectedEmail}
                    onChange={(e) => setSelectedEmail(e.target.value)}
                    disabled={contractorLoading}
                  >
                    <option value="">Select an email</option>
                    {role === 'qa' ? (
                      // Show contractors for qa role
                      (() => {
                        console.log('Rendering contractors for QA role:', contractors);
                        console.log('Contractors length:', contractors.length);
                        return contractors.map((contractor) => {
                          console.log('Rendering contractor:', contractor);
                          return (
                            <option key={contractor.id} value={contractor.email}>
                              {contractor.email}
                            </option>
                          );
                        });
                      })()
                    ) : (
                      // Show hardcoded emails for other roles
                      <>
                        <option value="mbilalkhk@gmail.com">mbilalkhk@gmail.com</option>
                        <option value="abdullah@unilever.com">abdullah@unilever.com</option>
                        <option value="faizanrasool806@gmail.com">faizanrasool806@gmail.com</option>
                      </>
                    )}
                  </Input>
                  {contractorLoading && role === 'qa' && (
                    <small style={{ color: '#6c757d', fontStyle: 'italic' }}>
                      Loading contractors...
                    </small>
                  )}
                  {role === 'qa' && !contractorLoading && (
                    <small style={{ color: '#28a745', fontStyle: 'italic' }}>
                      Found {contractors.length} active contractors
                    </small>
                  )}
                  
                </FormGroup>

                <FormGroup>
                  <Label for="messageText">Message</Label>
                  <Input
                    type="textarea"
                    id="messageText"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows={5}
                    placeholder="Enter your message to the selected contractor..."
                  />
                </FormGroup>
              </>
            )}

          </ModalBody>

          <ModalFooter>
            <Button 
              color="primary" 
              type="submit"
              disabled={role === 'qa' ? (!selectedEmail || !message.trim()) : false}
              style={{ 
                opacity: (role === 'qa' && (!selectedEmail || !message.trim())) ? 0.6 : 1 
              }}
            >
              {emailLoader ? (
                <>
                  Submitting <Spinner size="sm" color="light" />
                </>
              ) : (
                role === 'qa' ? 'Send Message & Submit' : 'Submit'
              )}
            </Button>
            <Button color="secondary" onClick={handleModalClose}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default EmailModal;